import template from './modal.html';
import '../modal.scss';

/**
 * @ngdoc controller
 * @name OdsModal
 * @description
 * This component renders the modal.
 */
class OdsModal {
  /**
   * @param {$scope}  $scope   To access the `apply` so we execute the callbacks in angular.
   * @param {$window} $window  To listen for the keydown event.
   */
  constructor(
    $scope,
    $window,
  ) {
    'ngInject';

    /**
     * The local reference to the `$scope` object.
     * @type {$scope}
     */
    this.$scope = $scope;
    /**
     * The local reference to the `$window` service.
     * @type {$window}
     */
    this.$window = $window;
    /**
     * The map of key codes.
     * @type {Object}
     * @access protected
     */
    this._keyCodes = {
        escape: 27,
        leftArrow: 37,
        rightArrow: 39,
    }
    /**
     * Bypass KeyDown event when the user is focused in one of the following elements
     * @type {Array}
     * @access protected
     */
    this._dontTriggerMoveHere = ['INPUT', 'TEXTAREA'];
    /**
     * @ignore
     */
    this.onKeydown = this.onKeydown.bind(this);
  }
  /**
   * Add the window keydown event listener.
   */
  $onInit() {
    this.$window.addEventListener('keydown', this.onKeydown, true);
  }
  /**
   * Clear the window listener.
   */
  $onDestroy() {
    this.$window.removeEventListener('keydown', this.onKeydown, true);
  }
  /**
   * Listen the keydown event on the window.
   * Triggers the `onClose` callback if the key is an `escape` (event.which === 27).
   * Triggers the `onPreviousClick` callback if the key is a `leftArrow` (event.which === 37).
   * Triggers the `onNextClick` callback if the key is a `rightArrow` (event.which === 39).
   *
   * @param {Event} event The keydown event.
   */
  onKeydown(event) {
    if (!this._dontTriggerMoveHere.includes(event.target.nodeName)) {
      switch (event.which) {
      case this._keyCodes.escape:
        this.$scope.$apply(() => this.onClose());
        break;
      case this._keyCodes.leftArrow:
        if (this.showNavigation) {
          this.$scope.$apply(() => this.onPreviousClick());
        }
        break;
      case this._keyCodes.rightArrow:
        if (this.showNavigation) {
          this.$scope.$apply(() => this.onNextClick());
        }
        break;
      default:
        break;
      }
    }
  }
}

/**
 * @ngdoc component
 * @name odsModal
 * @description
 * The modal component.
 */
export default {
  /**
   * The controller class for the component.
   * @type {OdsModal}
   */
  controller: OdsModal,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
  /**
   * Component bindings
   * @type {Object}
   * @property {String}   size             modal size. Options: small (see modal.scss)
   * @property {Boolean}  showNavigation   if the modal should display the navigation arrows.
   * @property {Function} onClose          callback when the close icon is clicked.
   * @property {Function} onNextClick      callback when the next button is clicked.
   * @property {Function} onPreviousClick  callback when the previous button is clicked.
   */
  bindings: {
    size: '@',
    showNavigation: '<',
    onClose: '&',
    onNextClick: '&',
    onPreviousClick: '&',
  },
  transclude: true,
};
